const Switch = ({
  id,
  inputClassName,
  className,
  isCheked = false,
  changeStatus = () => {},
  ...inputRest
}) => {
  return (
    <div onClick={changeStatus}>
      <label className={`switch ${className}`}>
        <input
          className={`${inputClassName}`}
          type="checkbox"
          id={id}
          checked={isCheked}
          {...inputRest}
        />
        <label className="slider" />
      </label>
    </div>
  )
}

export default Switch
